import { CountUp } from 'countup.js';

export default function chart1( el ) {
	if ( ! el ) {
		return;
	}

	console.log( 'chart1' );

	const options = {
		separator: '',
		decimal: '',
		suffix: '%',
		scrollSpyOnce: true,
		scrollSpyDelay: 100,
	};

	const counters = el.querySelectorAll( '[data-counter]' );
	counters.forEach( ( counter ) => {
		let number = 0;
		const value = counter.textContent.trim();
		let suffix = '';
		const separator = '.';
		let decimal = '';
		let decimalPlaces;

		if ( value.endsWith( '%' ) ) {
			number = parseFloat( value.replace( '%', '' ) );
			suffix = '%';
			decimal = '';
		} else if ( value.match( /x$/i ) ) {
			// "2.5x" гэх мэт үед
			number = parseFloat( value.replace( /x$/i, '' ) );
			suffix = 'x';
			decimal = '.';
			if ( value.includes( '.' ) ) {
				decimalPlaces = 1;
			}
		} else if ( value.includes( '.' ) ) {
			// 2.5 гэх мэт үед
			number = parseFloat( value );
			decimalPlaces = 1;
		} else {
			number = parseFloat( value );
		}

		const localOptions = {
			...options,
			suffix,
			separator,
			decimal,
			...( decimalPlaces !== undefined ? { decimalPlaces } : {} ),
			enableScrollSpy: true,
			scrollSpyDelay: 2000,
			duration: 2,
			scrollSpyOnce: true,
			onStartCallback: () => {
				counter.classList.add( 'countup-started' );
			}
		};

		counter.textContent = '';
		const demo = new CountUp( counter, number, localOptions );
		if ( ! demo.error ) {
			demo.start();
		} else {
			console.error( demo.error );
		}
	} );
}
